<template>
  
</template>

<script>
export default {
  data(){
    return{};
  },
  created() {
    this.$emit('changeMenu', 'SystemMessage'); 
  },
};
</script>

<style scoped>

</style>